import React, { useState} from 'react';
import {faqData} from "../js/faqData.js";
import FaqItem from "./FaqItem.js";
import unicornEasterFaq from "../images/10.png";

// https://github.com/myogeshchavan97/react-accordion-demo

const Faq = () => {
    const [isActive, setIsActive] = useState(false);

    let faqSchemaJson = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity" : []
    }
    return (
        <section id="faqContainer">
            <a href="#faq" className="anchor-target" name="faq">faq</a>
            <h2> FAQ</h2>
            <div className="accordion">
                {faqData.map(({ title, content }) => {
                    let faqJson = {
                        "@type": "Question",
                        "name": {title},
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": {content}
                        }
                    };
                    faqSchemaJson.mainEntity.push(faqJson);
                    return <FaqItem key={title} title={title} content={content} />
                })}
                {/* <div className={isActive ? "accordion-item active" : "accordion-item"}>
                    <div className="accordion-title" onClick={() => setIsActive(!isActive)}>
                        Is one of the hidden Unicorns under this question?
                        <span className="accordion-title-icon">{isActive ? '-' : '+'}</span>
                    </div>
                    <div className="accordion-content-container" >
                        <div className="accordion-content special">
                            <p className="roadmap-item-detail-sub">Yes, it is.</p>
                            <img className="faqImage" src={unicornEasterFaq} alt="Suddenly Unicorns 10" />
                        </div>
                    </div>
                </div> */}
            </div>

            <script type="application/ld+json">{JSON.stringify(faqSchemaJson)}</script>
        </section>
    );
};

export default Faq;